import { useEffect, useState } from 'react'

import DialogTitle from '@components/mui/DialogTitle'
import { Button, Dialog, DialogActions, DialogContent, Stack, TextField } from '@mui/material'
import { DialogProps } from '@toolpad/core/useDialogs'

import {
	checkDuplicateSources,
	getUnitMapsState,
	StringMap,
	StringMapError,
} from '../../FileLayoutEditor.utils'

export default function UnitStringMappingDialog({
	payload,
	open,
	onClose,
}: DialogProps<StringMap[], StringMap[] | null>) {
	const [unitMaps, setUnitMaps] = useState<StringMap[]>(getUnitMapsState(payload))
	const [error, setError] = useState<StringMapError>(null)

	useEffect(() => {
		if (open) {
			setTimeout(() => {
				const inputElementToFocus: HTMLInputElement = document.querySelector('#EACH')
				inputElementToFocus?.focus()
				// Places text cursor at end of text in field
				inputElementToFocus.setSelectionRange(
					inputElementToFocus.value.length,
					inputElementToFocus.value.length
				)
			}, 0)
		}
	}, [open])

	const handleSaveUnitMaps = () => {
		const mapWithError = checkDuplicateSources(unitMaps)
		if (mapWithError) {
			return setError(mapWithError)
		}
		onClose(unitMaps)
	}

	const handleEditUnitMaps = (value: string, id: string) => {
		const updatedUnitMaps = unitMaps.map((unitMap) =>
			unitMap.id === id ? { ...unitMap, sources: value } : unitMap
		)
		setUnitMaps(updatedUnitMaps)
	}

	return (
		<Dialog
			fullWidth
			maxWidth="sm"
			open={open}
			onClose={() => onClose(null)}
			closeAfterTransition={false}
		>
			<DialogTitle onClose={() => onClose(null)}>Code Mapping Editor</DialogTitle>
			<DialogContent dividers>
				<Stack gap={5} direction="row" flexWrap="wrap">
					{['EACH', 'FULL', 'HALF', 'SPLITWEIGHT', 'WEIGHT'].map((id) => (
						<TextField
							key={id}
							id={id}
							error={error?.id === id}
							helperText={error?.id === id && `Duplicate string: "${error.string}"`}
							label={id}
							value={unitMaps.find((unitMap) => unitMap.id === id).sources || ''}
							multiline
							rows={5}
							onChange={(e) => handleEditUnitMaps(e.target.value, id)}
							slotProps={{
								inputLabel: { shrink: true },
							}}
						/>
					))}
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={() => onClose(null)}>
					Cancel
				</Button>
				<Button variant="contained" onClick={handleSaveUnitMaps}>
					Save
				</Button>
			</DialogActions>
		</Dialog>
	)
}
